var _a;
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '../features/auth/authSlice';
import { chatMachineApi } from '../features/chat-machine/chat-machine-api';
import chatReducer from '../features/chat/chatSlice';
import globalSearchReducer from '../features/global-search/globalSearchSlice';
import commonReducer from '../features/common/commonSlice';
import CompanyChangeListener from '../features/common/middleware/company-change-middleware';
import { ErrorHandlingMiddleware } from '../features/common/middleware/error-handling-middleware';
import { monteurApi } from '../features/common/monteur-api';
import machineDocumentReducer from '../features/machine-documents/machine-documentSlice';
import folderViewReducer from '../features/folder-view/folderViewSlice';
import { pdokApi } from '../features/pdok/pdok-api';
var combinedReducers = combineReducers((_a = {},
    _a[monteurApi.reducerPath] = monteurApi.reducer,
    _a[chatMachineApi.reducerPath] = chatMachineApi.reducer,
    _a[pdokApi.reducerPath] = pdokApi.reducer,
    _a.auth = authReducer,
    _a.chat = chatReducer,
    _a.globalSearch = globalSearchReducer,
    _a.machineDocument = machineDocumentReducer,
    _a.folderView = folderViewReducer,
    _a.common = commonReducer,
    _a));
var rootReducer = function (state, action) {
    return combinedReducers(state, action);
};
export var store = configureStore({
    reducer: rootReducer,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({ serializableCheck: false })
            .concat(monteurApi.middleware)
            .concat(chatMachineApi.middleware)
            .concat(pdokApi.middleware)
            .concat(ErrorHandlingMiddleware)
            .concat(CompanyChangeListener.middleware);
    }
});
setupListeners(store.dispatch);
